<template>
  <div class="news-select-final">
    <h1 class="heading row justify-center">
      Klaar! De nieuwsbrief wordt aanstaande dinsdag aan je klanten verstuurd
    </h1>
    <div
      v-for="item in selectedNewsPerCustomer"
      :key="item.id"
      class="list-container"
    >
      <p class="news-title">
        {{ item.customerName }} - {{ item.news.length }} selected news items
      </p>
    </div>
    <div
      v-for="item in selectedSchemesPerCustomer"
      :key="item.id"
      class="list-container"
    >
      <p class="news-title">
        {{ item.customerName }} - {{ item.schemes.length }} selected schemes
        items
      </p>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import store from "../../store/index.js";
import salesForceService from "../../services/salesForceService";

export default {
  name: "NewsForCustomersFinal",
  setup() {
    const selectedNewsPerCustomer = computed({
      get: () => store.state.salesForce.selectedNewsPerCustomer,
    });

    const serverData = computed({
      get: () => store.state.salesForce.newsItemsPerCustomerListForServer,
    });

    const selectedSchemesPerCustomer = computed({
      get: () => store.state.salesForce.selectedSchemesPerCustomer,
    });

    const serverDataSchemes = computed({
      get: () => store.state.salesForce.schemeItemsPerCustomerListForServer,
    });

    onMounted(() => {
      salesForceService.postNewsSelection(
        serverData.value,
        serverDataSchemes.value,
        true
      );
    });
    return {
      serverData,
      selectedNewsPerCustomer,
      serverDataSchemes,
      selectedSchemesPerCustomer,
    };
  },
};
</script>
